import { CRM_SIGNUP } from '../constants/signupConstants';
import { HubletUrl } from '../utils/urls';
const setupExperiences = [
// ACQ143 - Free and Starter Relaunch
{
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/customize-your-crm/${portalId}/template`
    };
  },
  checks: [{
    signupExperimentTreatments: {
      'acq-0143': 'variant_a'
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/set-up-crm/${portalId}/templates`
    };
  },
  checks: [{
    signupType: CRM_SIGNUP
  }]
}];
export default setupExperiences;